import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { createMarkup } from '../utils';
import { TooltipInfo } from './icon/icons/TooltipInfo';
import { Panel } from './Panel';
import { Typography } from './Typography';
import { Spacer } from './Spacer';

export interface NoticeProps {
  heading?: string;
  text?: string;
}

const StyledNotice = styled.div`
  ${({ theme: { space } }) => css`
    display: flex;
    gap: ${space.md};

    svg {
      flex-shrink: 0;
    }
  `};
`;

export const Notice: FC<NoticeProps> = ({ heading, text, ...rest }) => (
  <Panel backgroundColor="white" {...rest}>
    <StyledNotice>
      <TooltipInfo color="accent3" size="default" />
      <Spacer spacing="quarter">
        <Typography variant="titleSmall">{heading}</Typography>
        <p>{createMarkup(text)}</p>
      </Spacer>
    </StyledNotice>
  </Panel>
);
